import React from 'react';
import './App.css';
import NavBar from './Component/NavBar';
import Footer from './Component/Footer';
import NoScreen from './Screens/NoScreen';
import ProductDetails from './Screens/ProductDetailsScreen';
import HomeScreen from './Screens/HomeScreen';
import {
  Route,
  useParams,
  Routes,
  BrowserRouter
} from "react-router-dom";
import LoginScreen from './Screens/LoginScreen';
import ProductsByCat from './Screens/ProductbyCatScreen';
import RegisterScreen from './Screens/RegisterScreen';
import AddProductScreen from './Screens/AddProductScreen';
import AddCategoryScreen from './Screens/AddCategoryScreen';
import AddReviewScreen from './Screens/AddReviewScreen';
import CartScreen from './Screens/CartScreen';
import CartDetailScreen from './Screens/CartdetailScreen';
import OrderScreen from './Screens/OrderScreen';
import OrderDetailsScreen from './Screens/OrderDetails';


const CartIdwrapper = () => {
  const {cartid} = useParams()
  const {userid} = useParams()
  return <CartDetailScreen cartid = {cartid} userid = {userid}/>
}

const OrderIdwrapper = () => {
  const {userid} = useParams();
  const {orderid} = useParams();
  return <OrderDetailsScreen userid = {userid} orderid = {orderid}/>
}


function App() {
  
  return (
    <div>
      <NavBar/>
        <BrowserRouter>
                  <Routes>
                    <Route exact path="/" element={<HomeScreen/>}/>
                    <Route path='/login' element={<LoginScreen/>}/>
                    <Route path ='/user' element={<RegisterScreen/>}/>
                    <Route path='/Addproduct' element={<AddProductScreen/>}/>
                    <Route path='/AddCategory' element={<AddCategoryScreen/>}/>
                    <Route path ='/AddReview/:productid' element={<AddReviewScreen/>}/>
                    <Route path='/products/category/:categoryid' element={<ProductsByCat/>}/>
                    <Route path="/products/:productId" element={<ProductDetails/>}/>
                    <Route path="/carts" element={<CartScreen/>}/>
                    <Route path= "/carts/:userid/:cartid" element={<CartIdwrapper/>}/>
                    <Route path="/orders" element={<OrderScreen/>}/>
                    <Route path="/orders/:orderid/user/:userid" element={<OrderIdwrapper/>}/>
                    <Route path="*" element={<NoScreen/>}/>
                  </Routes>
        </BrowserRouter>
      <Footer/>

       


        
    </div>
  );
}


export default App;
